export default "__VITE_ASSET__DvcMwmuc__"